import type { GetStaticProps, NextPage } from 'next';
import type { HeaderNav } from 'interfaces/navigation/Header';
import type { SitemapLink, SitemapPageLayout } from 'interfaces/navigation/Sitemap';
import { mockHeadData } from 'utils/metaDataUtils/headData';
import { SitemapPage } from 'pages/Sitemap/SitemapPage';
import { setMockPianoConfig } from 'services/Piano';
import mockPageData from 'lib/mockData/page-data';
import getFooter from 'api/Footer/getFooter';
import { getSitemapPageData } from 'utils/miscUtils/sitemapHelpers';
import type { PianoPageConfig } from 'services/Piano/entities/PianoPageConfig';
import { setarcSpanPageConfig } from 'services/ArcSpan';
import type { ArcSpanPageConfig } from 'services/ArcSpan/entities';
import handleStaticPropsError from 'utils/handleStaticPropsError';
import getMenu from 'api/Header/getMenu';
import { safeAsync } from 'utils/errorHandlingUtils';
import fallbackData from 'lib/fallbackData/commonData';

interface SitemapNextPageProps {
  urlList: SitemapLink[];
  sitemapPageLayout: SitemapPageLayout;
  pageTitle?: string;
}

const SitemapNextPage: NextPage<SitemapNextPageProps> = ({
  urlList,
  sitemapPageLayout,
  pageTitle,
}: SitemapNextPageProps) => (
  <SitemapPage
    urlList={urlList}
    sitemapPageLayout={sitemapPageLayout}
    pageTitle={pageTitle}
  />
);

export default SitemapNextPage;

export const getStaticProps: GetStaticProps = async (context) => {
  try {
    const menu: HeaderNav = await safeAsync(
      () => getMenu('LEFT_MENU_COM', 'RIGHT_MENU_COM', 'TOPIC_NAVIGATION_COM', 'own', null),
      fallbackData.headerNav,
    );
    const footer = await safeAsync(() => getFooter(), fallbackData.footer);
    const arcSpanPageConfig: ArcSpanPageConfig = setarcSpanPageConfig(mockPageData);
    const pianoPageConfig: PianoPageConfig = setMockPianoConfig();

    const { pageTitle, urlList, canonicalUrl, sitemapPageLayout } = await getSitemapPageData('rankings', context);
    const headData = { ...mockHeadData, canonicalUrl, title: pageTitle };

    return {
      props: {
        arcSpanPageConfig,
        footer,
        headData,
        headerNav: menu,
        pageTitle,
        pianoPageConfig,
        sitemapPageLayout,
        urlList,
      },
      revalidate: 86400,
    };
  } catch (e) {
    return handleStaticPropsError(e as Error);
  }
};
